module.exports = __webpack_public_path__ + "img/y_2018_1.f0f12f7c.png";